import { FC, forwardRef, LiHTMLAttributes } from 'react';
import { cn, A11yButton, A11yButtonProps } from '@fe-learner-common';
interface ListItemProps extends LiHTMLAttributes<HTMLLIElement> {
  disabled?: boolean;
}

export const ListItem: FC<ListItemProps> = ({ children, disabled, role }) => {
  return (
    <li
      role={role}
      className={cn(
        'relative cursor-pointer md:items-center [&>:first-child]:mb-2',
        'after:content after:absolute after:bottom-0 after:left-4 after:right-4 after:border-b-1 after:border-neutral-100',
        {
          'cursor-not-allowed': disabled,
        },
      )}
    >
      {children}
    </li>
  );
};

export const ListButton = forwardRef<HTMLButtonElement, A11yButtonProps>(
  ({ className, children, disabled, role, ...rest }, ref) => {
    return (
      <ListItem disabled={disabled} role={role}>
        <A11yButton
          ref={ref}
          disabled={disabled}
          className={cn(
            'l-btn-tertiary flex w-full items-start gap-4 rounded-lg p-4 text-neutral-900',
            className,
          )}
          {...rest}
        >
          {children}
        </A11yButton>
      </ListItem>
    );
  },
);

ListButton.displayName = 'ListButton';
